/* Tysk katalog for locale-bank-archive-filter-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'bank.archive.filter.postingType': 'Buchungsart',
  'bank.archive.filter.purchase': 'Einkauf',
  'bank.archive.filter.otherSale': 'Sonstiger Verkauf',
  'bank.archive.filter.payment': 'Zahlung',
  'bank.archive.filter.manualPosting': 'Freie Buchung',
  'bank.archive.filter.bankPosting': 'Bankbuchung',
  'bank.archive.filter.publicPayment': 'Lohn und Abgaben',
  'bank.archive.filter.ignored': 'Ignorierte Bankzeile',
  'bank.archive.filter.documentation': 'Dokumentation',
  'bank.archive.filter.missingAttachment': 'Beleg fehlt',
  'bank.archive.filter.hasAttachment': 'Mit Beleg',
  'bank.archive.sort.label': 'Buchungen sortieren',
  'bank.archive.sort.statementOrder': 'Reihenfolge im Kontoauszug',
  'bank.archive.sort.dateDesc': 'Datum: neueste zuerst',
  'bank.archive.sort.dateAsc': 'Datum: älteste zuerst',
  'bank.archive.sort.amountDesc': 'Betrag: höchster zuerst',
  'bank.archive.sort.amountAsc': 'Betrag: niedrigster zuerst',
});
